export default {
  esg_data: {
    total_answer_progress: '全体の回答推移',
    shared_companies: '共有社数',
    main_title: 'ESGデータシェア',
    sub_title_answer: '回答データ',
    create_new_data: '新規データ作成',
    answer_list: {
      section_one: '自社のESGデータを入力して、サプライチェーン企業と共有しましょう。',
      section_two: '他社のサーベイ回答にも活用でき、繰り返しの回答負担を減らせます。データはすべて埋まっていなくても共有可能です。',
    },
    create_data_modal: {
      title: 'データを作成する',
      data_name_auto: '[会社名]_[年度]_ESGデータで自動生成されています',
      standard_explain: '基本的なESG情報を入力できるデータセットです。',
      enter_prise_explain: '幅広いESG情報を網羅したデータセットです。',
    },
    data: 'データ',
    template: 'テンプレート',
    select: '@:upload_common.target_select',
    share_data: 'データ共有する',
    total_answer_progress_of_esg_data: 'ESGデータ全体の回答進捗',
    share_data_modal: {
      title: 'データを共有する',
      message_one: '自社のESGマスタを共有したい企業のメールアドレスを入力してください。',
      message_two: '閲覧のための招待リンクが送られます。',
      caution_title: '@:settings.cautions_title',
      caution_one: '最大3社のアカウントに共有することができます。',
      caution_two: '回答データを共有した後に、データを更新することはできません。',
      share: '共有する',
    },
    email: 'メールアドレス',
    message: 'メッセージ',
    sub_title_share: '共有データ',
    shared_date: '共有日時',
    unshare: '共有を解除',
    unshare_data_modal: {
      title: 'データ共有を解除',
      message: '{target}とのデータ共有を解除しますか？',
      unshare: '解除',
    },
    data_name: 'データ名',
    data_count: 'データ数',
    esg_data: 'ESGデータ',
    category_company: '@:settings.company.title',
    company_name: '企業名',
    sharing_company: 'データ共有中',
    other_persons: '他{otherUserCount}名',
    invitation_message: '招待リンクを送信しました。\n共有状況は「共有データ」ページから確認ができます。',
  },
}
